import { mapState, mapGetters, mapActions } from 'vuex';

const authComputed = {
    ...mapState('authfack', {
        currentUser: (state) => state.user
    }),
    ...mapGetters('authfack', ['loggedIn'])
};

const masterComputed = {
    ...mapState('master', {
        dataList: (state) => state.dataList
    })
};

const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layoutType,
        leftSidebarType: (state) => state.leftSidebarType,
        layoutWidth: (state) => state.layoutWidth,
        topbar: (state) => state.topbar,
        loader: (state) => state.loader
    })
};

const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue']);

const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout', 'profile', 'forgot', 'resetPass']);

const masterMethods = mapActions('master', [
    'setDefaultCampaign',
    'postDocumentFAQPreview',
    'postDocumentParameterFMT',
    'postDocumentContactFMT',
    'postDocumentFAQ',
    'deleteDocumentFAQ',
    'restoreDocumentFAQ',
    'updateDocumentFAQ',
    'getDocumentFAQ',
    'getDefaultRule',
    'createMasterRuleDetail1',
    'getDetailDocuments',
    'getAllDocuments',
    'updateMasterRuleDetail1',
    'detailMasterRule1',
    'getAllMasterRule',
    'deleteMasterRule2',
    'createMasterRule1',
    'deleteMasterRule1',
    'updateMasterRule1',
    'updateMasterRule',
    'listMasterRule1',
    'registerMasterRule',
    'updateRule2',
    'deleteRule2',
    'createRule2',
    'listRule',
    'documentPreview',
    'templateDelete',
    'templateCreate',
    'templateUpdate',
    'removeDraf',
    'saveDraf',
    'templateGetDraf',
    'templateGetDetail',
    'templateList',
    'deleteMasterHolidayYear',
    'updateHolidayYear',
    'listHolidayYear',
    'oneHolidayYear',
    'registerHolidayYear',
    'deleteMasterHoliday',
    'updateHoliday',
    'listHoliday',
    'registerHoliday',
    'histories',
    'findCompany',
    'searchAddress',
    'registerPermission',
    'dataPermission',
    'listPermission',
    'listPartnerRoles',
    'listMaster',
    'registerMaster',
    'deleteMaster',
    'updateMaster',
    'masterCampaigns',
    'getListScheduleFile',
    'getDataByCondition',
    'getDetailScheduleFile',
    'createScheduleFile',
    'updateScheduleFile',
    'deleteScheduleFile',
    'partnerRequestSheet',
    'getPartnerRequestSheet',
    'updatePartnerRequestSheet',
    'updateCheckValuePartnerRequestSheet',
    'getMasterOrderScope',
    'getAllPartners',
    'getListPartners',
    'getAllTools',
    'actionDataParamaterFMT',
    'actionDataContactFMT',
    'detailAllMasterRule',
    'getDetailRuleCondition',
    'getListHolidayFilter'
]);

const employeeMethods = mapActions('employee', [
    'listEmployeePartTime',
    'registerEmployeePartTime',
    'registerEmployee',
    'detailEmployeePartTime',
    'updateEmployeePartTime',
    'updateEmployee',
    'listEmployee',
    'deleteEmployee',
    'detailEmployee',
    'deleteEmployeePartTime'
]);

const partnersMethods = mapActions('partners', [
    'registerPartners',
    'updatePartners',
    'listPartners',
    'deletePartners',
    'detailPartners',
    'listPartnersSupport',
    'registerPartnersSupport',
    'updatePartnersSupport',
    'detailPartnersSupport',
    'deletePartnersSupport',
    'getPartnersSettingPhone',
    'CHECK_PARTNER_ORDER_SCOPE_CAMPAIGN'
]);

const clientMethods = mapActions('client', [
    'registerClient',
    'updateClient',
    'listClient',
    'deleteClient',
    'detailClientSupport',
    'listClientSupport',
    'registerClientSupport',
    'updateClientSupport',
    'deleteClientSupport',
    'detailClient'
]);

const campaignMethods = mapActions('campaign', [
    'historyDocuments',
    'postDocuments',
    'deleteHistoryDocuments',
    'copyCampaign',
    'uploadFile',
    'readFileUpload',
    'getDocuments',
    'triggerDocuments',
    'deleteBookmark',
    'getBookmark',
    'addBookmark',
    'approveCampaign',
    'unLockCampaign',
    'lockCampaign',
    'registerCampaign',
    'updateCampaign',
    'updateQuickCampaign',
    'updateMassStatusCampaign',
    'listCampaign',
    'deleteCampaign',
    'detailCampaign',
    'getDataDocuments',
    'getRuleSavePayLoad',
    'postRuleSavePayLoad',
    'setBookmarkCampaign',
    'unsetBookmarkCampaign',
    'downloadCampaignData',
    'syncStatusFaqForCampaign',
    'getHistoryList'
]);

const faqMethods = mapActions('faq', [
    'registerFaq',
    'updateFaqs',
    'updateFaqsAnswerDefault',
    'listFaqs',
    'deleteFaq',
    'detailFaq',
    'listPartnersSupport',
    'registerAnswer',
    'updateAnswer',
    'detailPartnersSupport',
    'deleteAnswer'
]);

const prizeMethods = mapActions('prize', [
    'deletePrizeReturn',
    'listPrizeReturn',
    'registerPrizeReturn',
    'updatePrizeReturn',
    'registerPrize',
    'updatePrize',
    'updateFaqsAnswerDefault',
    'listPrize',
    'deletePrize',
    'detailPrize',
    'registerAnswer',
    'updateAnswer',
    'detailPartnersSupport',
    'deleteAnswer',
    'getPrizesAll'
]);

const notificationMethods = mapActions('notification', ['success', 'error', 'clear']);

const dashboardMethods = mapActions('dashboard', ['listCountEmployeeDashboard', 'GET_LIST_CAMPAIGN_FOR_DASHBOARD']);

const settingPhoneMethods = mapActions('settingPhone', [
    'detailPhone',
    'registerPhone',
    'updatePhone',
    'updateStepWorkflow',
    'getListUserInRoom',
    'getInfoChatWork',
    'getTemplateConfig'
]);

const manualService = mapActions('manual', ['detailManual', 'updateManual']);

const landingPageMethods = mapActions('landingPage', [
    'registerLandingPage',
    'copyLandingPage',
    'syncLandingPagePublish',
    'updateLandingPage',
    'getListLandingPage',
    'getDetailLandingPage',
    'deleteLandingPage',
    'getDetailCampaignForLandingPage',
    'settingOverral',
    'incrementRefresh'
]);

const managerFormMethods = mapActions('managerForm', [
    'registerManagerForm',
    'updateManagerForm',
    'getListManagerForm',
    'getAnalytics',
    'getRegisterEmailsAnalytics',
    'getListBlockOriginalOfForm',
    'getListBlockOfForm',
    'getListBlockOfFormSerial',
    'getListOptionOfBlock',
    'updateAnalytics',
    'deleteAnalytics',
    'getDetailManagerForm',
    'deleteManagerForm',
    'saveStateBlockForm',
    'updateBlockList',
    'updateMessages',
    'updateButtonEvent',
    'syncFormPublish',
    'settingPublishTime',
    'stopPublishNow',
    'exportDataBlockForm',
    'exportDataRegisterEmail',
    'getListTemplateManagerForm',
    'registerTemplateManagerForm',
    'getDetailTemplateManagerForm',
    'formSettingEmail',
    'getDetailSettingEmail',
    'copyFormApi',
    'getListDomainEmail',
    'registerDomainEmail',
    'updateDomainEmail',
    'deleteDomainEmail',
    'getListCustomDomain',
    'registerCustomDomain',
    'updateCustomDomain',
    'deleteCustomDomain',
    'getListEmailSender',
    'registerEmailSender',
    'updateEmailSender',
    'deleteEmailSender',
    'getListEmailReply',
    'getListAllEmailReply',
    'getListAllEmailFrom',
    'registerEmailReply',
    'updateEmailReply',
    'deleteEmailReply',
    'deleteFormAndData',
    'deleteAllResultAnalytics',
    'deletePermanentlyResultAnalytics',
    'deletePermanently',
    'sendMailTest',
    'registerTemplateMail',
    'getListAllTemplateMail',
    'updateTemplateMail',
    'deleteTemplateMail',
    'importSerialCode',
    'downloadSerialCode',
    'importProductForPrize',
    'downloadProductForPrize',
    'autoGenSerialCode',
    'getDailyLimitsPrizeForm',
    'getAnalyticsLottery',
    'downloadLotteryHistory',
    'downloadSerialCodes',
    'getListSerialCode',
    'getListSerialCodeAnalytics',
    'createSerialCode',
    'updateSerialCode',
    'deleteSerialCode',
    'downloadListSerialCode',
    'jobCheckImportSerial',
    'jobCheckAutoGenSerial',
    'jobDeleteListSerial',
    'jobDeleteS3AnalyticsStatus',
    'checkStatusCopySerial'
]);

const editorMethods = mapActions('editor', ['registerDataEditor']);

const uploadMethods = mapActions('upload', ['acUploadImage', 'acUploadVideo', 'acgetJobStatusFile']);

const lotteryMethods = mapActions('lottery', [
    'acRegisterExternalLottery',
    'acUpdateExternalLotteryFile',
    'acGetExternalImportStatus',
    'acGetExternalDataColumns',
    'listLottery',
    'detailLottery',
    'registerLottery',
    'updateLottery',
    'deleteLottery',
    'settingLottery',
    'candidatesPreview',
    'exportCandidates',
    'drawLottery',
    'drawStatus',
    'listWinners',
    'addWinner',
    'updateWinner',
    'deleteWinner',
    'exportWinners'
]);

export {
    authComputed,
    masterComputed,
    layoutComputed,
    layoutMethods,
    authFackMethods,
    masterMethods,
    employeeMethods,
    partnersMethods,
    clientMethods,
    campaignMethods,
    faqMethods,
    prizeMethods,
    notificationMethods,
    dashboardMethods,
    settingPhoneMethods,
    manualService,
    landingPageMethods,
    managerFormMethods,
    editorMethods,
    uploadMethods,
    lotteryMethods
};
